module.exports = __webpack_public_path__ + "static/img/zengzhishuifapigrey@3x90c6476.png";